<router-outlet></router-outlet>

<div class="sidepanes-anchor">
  <router-outlet name="settings"></router-outlet>
</div>
